import React from 'react';
import PropTypes from 'prop-types';

const View = (props) => {
  const {
    bioQuestions,
    ViewComponent,
    isComplete,
    setIsComplete,
    ...restProps
  } = props;

  return (
    <ViewComponent
      bioQuestions={bioQuestions}
      isComplete={isComplete}
      setIsComplete={setIsComplete}
      {...restProps}
    />
  );
};

View.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  ViewComponent: PropTypes.elementType.isRequired,
  isComplete: PropTypes.bool,
  setIsComplete: PropTypes.func.isRequired,
};

export default React.memo(View);
